import React, { useState, useEffect } from "react";
import axios from "axios";

import { ProgressBar } from "./pages/keyless/components/ProgressBar";

export function TestPage(props) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  
  useEffect(() => {

    async function func() {
      const res = await axios.get('/test', { withCredentials: true })
      setData(res.data);
    }

    func()

  }, []);

  return (
    <div>
      {data && (
        <p>
          Data: {data.type} - {data.browser} - {data.os}
        </p>
      )}
      {data && <div><pre>{JSON.stringify(JSON.parse(data.rawResult), null, 2) }</pre></div>}
      {error && <p>Error: {error.message}</p>}
    </div>
  );
}
